import React from 'react';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { sharedStyles } from './SharedPDFStyles';

const DugunReportPDF = ({ data, logos }) => {
  return (
    <Document>
      <Page size="A4" style={sharedStyles.page}>
        <View style={sharedStyles.header}>
          <View style={sharedStyles.businessInfo}>
            {logos.length > 0 && (
              <View style={sharedStyles.logoContainer}>
                {logos.slice(0, 3).map((logo, index) => (
                  <Image key={index} src={logo.data} style={sharedStyles.logo} />
                ))}
              </View>
            )}
            <Text style={sharedStyles.businessName}>{data.eventName || 'Event Name'}</Text>
            <Text style={sharedStyles.businessDetails}>Client: {data.clientName}</Text>
            <Text style={sharedStyles.businessDetails}>Location: {data.location}</Text>
          </View>
          <View style={sharedStyles.documentTitle}>
            <Text style={sharedStyles.title}>Event Proposal</Text>
            <Text style={sharedStyles.documentInfo}>Date: {data.date}</Text>
            <Text style={sharedStyles.documentInfo}>Event Date: {data.eventDate}</Text>
          </View>
        </View>

        <View style={sharedStyles.section}>
          <Text style={sharedStyles.sectionTitle}>Services</Text>
          <View style={sharedStyles.table}>
            <View style={sharedStyles.tableHeader}>
              <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>Service Type</Text>
              <Text style={sharedStyles.tableCellRight}>Price</Text>
              <Text style={sharedStyles.tableCellRight}>Deposit</Text>
              <Text style={sharedStyles.tableCellRight}>Remaining</Text>
            </View>
            {data.services && data.services.map((service, index) => (
              <View key={index} style={sharedStyles.tableRow}>
                <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>{service.serviceName}</Text>
                <Text style={sharedStyles.tableCellRight}>${service.price.toFixed(2)}</Text>
                <Text style={sharedStyles.tableCellRight}>${service.deposit.toFixed(2)}</Text>
                <Text style={sharedStyles.tableCellRight}>${service.remaining.toFixed(2)}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={sharedStyles.summary}>
          <View style={sharedStyles.summaryBox}>
            <View style={sharedStyles.summaryRow}>
              <Text style={sharedStyles.summaryLabel}>Total Price:</Text>
              <Text style={sharedStyles.summaryValue}>${data.totalPrice?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryRow}>
              <Text style={{ ...sharedStyles.summaryLabel, color: '#4CAF50' }}>Total Deposit:</Text>
              <Text style={{ ...sharedStyles.summaryValue, color: '#4CAF50' }}>${data.totalDeposit?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryTotal}>
              <Text style={sharedStyles.summaryTotalLabel}>Remaining Balance:</Text>
              <Text style={sharedStyles.summaryTotalValue}>${data.totalRemaining?.toFixed(2) || '0.00'}</Text>
            </View>
          </View>
        </View>

        {data.notes && (
          <View style={sharedStyles.notes}>
            <Text style={sharedStyles.notesTitle}>Notes:</Text>
            <Text style={sharedStyles.notesText}>{data.notes}</Text>
          </View>
        )}

        <View style={sharedStyles.footer}>
          <Text> Crafted by Eng. Mohamed Ibrahim Abdi (Moha-Qadar) | 🎓 KTÜ & Firat University | 📧 mohamedqadar280@gmail.com | 💬 Feedback</Text>
        </View>
      </Page>
    </Document>
  );
};

export default DugunReportPDF;
